export default __webpack_public_path__ + "static/media/gallery-31.357e6055.jpg";